module.exports = __webpack_public_path__ + "static/media/icon-youtube.8e482daa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-youtube.svg
// module id = 398
// module chunks = 0